import type { Iso20022Address } from './AddressSearch'

// A structured address carries at least one component beyond the type and country.
// Free text typed without picking a suggestion has none.
export const hasStructuredAddress = (iso?: Iso20022Address): iso is Iso20022Address =>
  !!iso && Boolean(iso.streetName || iso.buildingNumber || iso.postCode || iso.townName)

// wizardAddressProperties returns the address properties the site creation wizard
// sends. address_raw is always the typed text; address_iso20022 only when a
// structured suggestion was picked. Free text is never dressed up as a clean
// address: the asset_geocode job produces it (spec 2026-09-30-09).
export function wizardAddressProperties(
  address: string | undefined,
  iso?: Iso20022Address,
): { address_raw?: string; address_iso20022?: Iso20022Address } {
  const out: { address_raw?: string; address_iso20022?: Iso20022Address } = {}
  if (address?.trim()) out.address_raw = address
  if (hasStructuredAddress(iso)) out.address_iso20022 = iso
  return out
}
